export default __webpack_public_path__ + "static/media/Groupe 622.2c6647cd.png";